import { render, staticRenderFns } from "./OutrosCursos.vue?vue&type=template&id=4f925f3a&"
import script from "./OutrosCursos.vue?vue&type=script&lang=js&"
export * from "./OutrosCursos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports